const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Resets the password of users who requested a password reset
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('reset', ['Users', 'Application', 'Authorization', '$location', '$translate', function(Users, Application, Authorization, $location, $translate) {
    return {
      restrict: 'E',
      template: require('../../../templates/directives/preauth/reset.html'),
      controller: function() {
        var self = this;
        var params = Application.navigation.getUrlParameters();
        var url = Application.navigation.getUrl();
        if (!params.key || url.indexOf('reset') === -1) {
          return;
        }
        var domain = Application.companyDomain;
        self.displaySuccess = false;
        self.credentials = {domain: domain, email: params.email, key: params.key, password: ''};
        self.loading = false;

        self.pressEnter = function(keyPress) {
          if (keyPress !== 'click' && keyPress.which !== 13) {
            return;
          }

          if (!self.credentials.password || self.credentials.password.length < 5 || self.credentials.password !== self.confirmPassword) {
            Application.messaging.addMessage({type: 'error', text: self.translations['preauth.reset.invalid_password'], duration: 5});
            return;
          }

          if (self.credentials.email && self.credentials.password) {
            self.submitPassword();
          }
        };
        self.goToLogin = function() {
          Application.navigation.goTo('signin');
          $location.search('key', null);
          $location.search('email', null);
        };
        self.submitPassword = function() {
          self.loading = true;
          Users.reset({}, self.credentials, function(data) {
            self.loading = false;
            self.displaySuccess = true;
          }, function(error) {
            self.loading = false;
            Authorization.clearAuthToken();
            console.log('Error', error);
            Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidCredentials'], duration: 5});
          });
        };

        $translate([
          'modules.notifications.invalidCredentials',
          'preauth.reset.invalid_password'
        ]).then(function(data) {
          self.translations = data;
        });

      },
      controllerAs: 'resetPass'
    };
  }]);
